import r from"react";import{MdIcon as t}from"./MdIcon.js";import{mdiArrowLeft as o}from"@mdi/js";const e=({id:e="arrow",title:i="Arrow",...m})=>r.createElement(t,{id:e,title:i,path:o,...m});export{e as ArrowIcon};
